import api from '../api'
import fetchDelayed from '@/store/helper/fetchDelayed'
import _ from 'underscore'

const fetch = (context, args, delay=500) => {
  if(_.has(args, 'delay')){
    delay = parseInt(args.delay);
    delete(args.delay);
  }

  return fetchDelayed.fetch(
    api,
    context,
    null,
    args,
    delay
  );
}

export default {
  fetch,
}
